import { Link } from "@/lib/router-compat";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { HOMEPAGE_ABOUT_HEADLINE, HOMEPAGE_ABOUT_BODY } from "@/data/aboutData";

const AboutUsBand = () => {
  return (
    <section className="py-12 md:py-16 bg-muted/30">
      <div className="container mx-auto px-4 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl"
        >
          <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-3">
            {HOMEPAGE_ABOUT_HEADLINE}
          </h2>
          <p className="text-muted-foreground text-base md:text-lg leading-relaxed mb-5">
            {HOMEPAGE_ABOUT_BODY}
          </p>
          <Link
            to="/about"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary hover:text-primary/80 transition-colors"
          >
            Read more about us <ArrowRight className="h-4 w-4" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default AboutUsBand;
